import { createContext, useContext, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/lib/LanguageContext";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import HomePage from "@/pages/HomePage";
import HousesPage from "@/pages/HousesPage";
import HouseDetailPage from "@/pages/HouseDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import MenuPage from "@/pages/MenuPage";
import BookingPage from "@/pages/BookingPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ContactsPage from "@/pages/ContactsPage";
import OrderPage from "@/pages/OrderPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminHouses from "@/pages/admin/AdminHouses";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminServices from "@/pages/admin/AdminServices";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminReviews from "@/pages/admin/AdminReviews";

import AdminOrders from "@/pages/admin/AdminOrders";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminClients from "@/pages/admin/AdminClients";
import AdminLoyalty from "@/pages/admin/AdminLoyalty";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminVenues from "@/pages/admin/AdminVenues";
import AdminPayments from "@/pages/admin/AdminPayments";
import OrderReceiptPrint from "@/pages/admin/OrderReceiptPrint";
import SessionReceiptPrint from "@/pages/admin/SessionReceiptPrint";

export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("eco_user");
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("eco_token"));

  const login = (userData, tokenStr) => {
    setUser(userData);
    setToken(tokenStr);
    localStorage.setItem("eco_user", JSON.stringify(userData));
    localStorage.setItem("eco_token", tokenStr);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("eco_user");
    localStorage.removeItem("eco_token");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/houses" element={<HousesPage />} />
              <Route path="/houses/:id" element={<HouseDetailPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/contacts" element={<ContactsPage />} />
              <Route path="/order" element={<OrderPage />} />
            </Route>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/print/order/:id" element={user ? <OrderReceiptPrint /> : <Navigate to="/admin/login" />} />
            <Route path="/admin/print/session/:id" element={user ? <SessionReceiptPrint /> : <Navigate to="/admin/login" />} />
            <Route path="/admin" element={user ? <AdminLayout /> : <Navigate to="/admin/login" />}>
              <Route index element={<AdminDashboard />} />
              <Route path="houses" element={<AdminHouses />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="inventory" element={<AdminInventory />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="loyalty" element={<AdminLoyalty />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="menu" element={<AdminMenu />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="venues" element={<AdminVenues />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      </HelmetProvider>
    </AuthContext.Provider>
  );
}

export default App;
